import React, { useEffect } from 'react';
import Button from 'component/button';
import * as PAGES from 'constants/pages';
import { useLocation } from 'react-router-dom';
import classnames from 'classnames';
export default function Footer() {
  useEffect(() => {
    const maxTimeout = 2000;
    let elapsedTime = 0;

    function checkForOneTrust() {
      elapsedTime = elapsedTime + 500;
      if (elapsedTime > maxTimeout) return;

      if (!window.Optanon) {
        window.setTimeout(checkForOneTrust, 500);
      } else {
        const privacyFooterButton = document.getElementById('gdprPrivacyFooter');
        if (privacyFooterButton) privacyFooterButton.style.display = 'block';
      }
    }

    checkForOneTrust();
  }, []);
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const isShorts = urlParams.get('view') === 'shorts';

  return (
    <footer
      className={classnames('footer', {
        'footer--shorts': isShorts,
      })}
    >
      <ul className="navigation__tertiary footer__links">
        <li className="footer__link">
          <Button
            label={__('Community Guidelines')}
            href="https://help.odysee.tv/communityguidelines/"
            target="_blank"
          />
        </li>
        <li className="footer__link">
          <Button label={__('FAQ')} href="https://help.odysee.tv/" target="_blank" />
        </li>
        <li className="footer__link">
          <Button label={__('Support --[used in footer; general help/support]--')} href="https://help.odysee.tv/" />
        </li>
        <li className="footer__link">
          <Button label={__('Contribute')} navigate={`/$/${PAGES.CONTRIBUTE}`} />
        </li>
        <li className="footer__link">
          <Button label={__('Terms')} href="https://odysee.com/$/tos" />
        </li>
        <li className="footer__link">
          <Button label={__('Privacy Policy')} href="https://odysee.com/$/privacypolicy" />
        </li>
        <li className="footer__link" id="gdprPrivacyFooter">
          <Button label={__('Cookie Settings')} onClick={() => window.Optanon && window.Optanon.ToggleInfoDisplay()} />
        </li>
      </ul>
    </footer>
  );
}
